import { createSelector } from 'reselect';
import { loginRootReducerStateKey } from '../rootReducer';
import { CoreState } from '../types';

type RootState = {
  [loginRootReducerStateKey]: CoreState;
};

export const getSlice = (state: RootState): CoreState => state[loginRootReducerStateKey];

export const getLoggedUser = createSelector(getSlice, coreState => coreState.user);

export const getAccessToken = createSelector(getLoggedUser, user => user?.access_token);

export const getRefreshToken = createSelector(getLoggedUser, user => user?.refresh_token);
